// extracted by mini-css-extract-plugin
export default {"modal__header":"modal_modal__header__TE7xq","modal__content":"modal_modal__content__7NiXG"};